import axios from "axios";

import Vuex from "../store";
import router from "../router";
var baseURL = getVueEnv('VUE_APP_API_BASE_URL');
window.localStorage.setItem("service_cname", baseURL);

const http = axios.create({
  baseURL: baseURL + "/agent", //线上
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  // timeout: 10000
});

//添加请求头
http.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.common["token"] = sessionStorage.getItem("token");
    }
    config.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
    config.headers.common["client"] = Vuex.state.client;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

/* 响应拦截器 */
http.interceptors.response.use(
  function(response) {
    // ①10010 token过期（30天） ②10011 token无效
    // if (response.data.code === 10010 || response.data.code === 10011) {
    if (response.data.code < -1) {
      console.log("你的token失效了");
      // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
      window.sessionStorage.clear();
      Vuex.state.checktabs = "";
      // alert("登录失效请返回重新登陆");
      this.$message({
        type: "warning",
        message: "你的token失效了,请重新登录!",
      });
      router.replace({
        path: "/login", // 到登录页重新获取token
      });
    } else if (response.data.token) {
      // 判断token是否存在，如果存在说明需要更新token
      Storage.localSet("token", response.data.token); // 覆盖原来的token(默认一天刷新一次)
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);
export default http;
